import { faEye, faPlay, faRobot, faStop, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { formatDateTimeUA } from 'helpers/formatDate';
import { Tooltip } from 'components/Tooltip';
import { Button } from 'components/Button';
import styles from './SessionHistory.scss';

export const SessionRow = ({
  session,
  canManage,
  onCloseSession,
  formatDuration,
  expandedSession,
  setExpandedSession,
}) => {
  const isActive = session.isActive;

  const getCurrentSessionDuration = (loginTime) => {
    const now = new Date();
    const login = new Date(loginTime);
    return Math.floor((now - login) / (1000 * 60));
  };

  const toggleSessionDetails = () => {
    setExpandedSession(expandedSession === session.id ? null : session.id);
  };

  const getSessionTypeIcon = (type) => {
    switch (type) {
      case 'auto_logout':
        return faRobot;
      default:
        return faUser;
    }
  };

  const getSessionTypeLabel = (type) => {
    switch (type) {
      case 'auto_logout':
        return 'Автовихід';
      default:
        return 'Звичайний';
    }
  };

  const currentDuration = isActive ? getCurrentSessionDuration(session.loginTime) : null;

  return (
    <>
      <td className={cn(styles.sessionType, { [styles.active]: isActive })}>
        <FontAwesomeIcon icon={getSessionTypeIcon(session.sessionType)} />
        <Tooltip className={styles.tooltip} text={getSessionTypeLabel(session.sessionType)} position='right' />
      </td>
      <td>{formatDateTimeUA(session.loginTime, true)}</td>
      <td>
        {isActive ? (
          <span className={styles.activeLabel}>
            <FontAwesomeIcon icon={faPlay} />
            Активна
          </span>
        ) : session.logoutTime ? (
          formatDateTimeUA(session.logoutTime, true)
        ) : (
          '—'
        )}
      </td>
      <td>
        {isActive ? (
          <span className={styles.liveDuration}>
            {formatDuration(currentDuration)}
            <span className={styles.live}>●</span>
          </span>
        ) : (
          formatDuration(session.sessionDuration)
        )}
      </td>
      <td className={styles.statusCell}>
        <span className={cn(styles.status, { [styles.active]: isActive, [styles.completed]: !isActive })}>
          {isActive ? 'Активна' : 'Завершена'}
        </span>
      </td>
      <td className={styles.actions}>
        <Button className={styles.btn} onClick={toggleSessionDetails} noStyle>
          <FontAwesomeIcon icon={faEye} />
        </Button>
        {isActive && canManage && (
          <Button onClick={() => onCloseSession(session.id)} className={cn(styles.btn, styles.closeBtn)} noStyle>
            <FontAwesomeIcon icon={faStop} />
          </Button>
        )}
        {expandedSession === session.id && (
          <div
            className={styles.expandedInfo}
            onMouseLeave={() => {
              expandedSession === session.id && toggleSessionDetails();
            }}
          >
            <div className={styles.detailItem}>
              <strong>ID сесії:</strong> {session.id}
            </div>
            <div className={styles.detailItem}>
              <strong>IP адреса:</strong> {session.ipAddress || 'Невідома'}
            </div>
            <div className={styles.detailItem}>
              <strong>User Agent:</strong> {session.userAgent || 'Невідомий'}
            </div>
            <div className={styles.detailItem}>
              <strong>Створена:</strong> {formatDateTimeUA(session.createdAt)}
            </div>
            {session.updatedAt !== session.createdAt && (
              <div className={styles.detailItem}>
                <strong>Оновлена:</strong> {formatDateTimeUA(session.updatedAt)}
              </div>
            )}
          </div>
        )}
      </td>
    </>
  );
};
